export const VotePanel = ({ game }: { game: typeof GAMES.lostCrusader }) => {
  // const { tasks } = game

  return (
      <div className="flex flex-col gap-2 p-2 rounded-lg border border-solid border-[#212425]">
        <div className="flex items-center relative gap-1.5 px-1 py-2">
          <p className="text-[13px] font-medium text-left text-white">
            Pending Votes
          </p>
          <p className="text-[13px] font-bold text-left text-[#60e25e]">0</p>
        </div>
        {/* <div className="flex flex-col justify-center items-start relative gap-3 p-4 rounded-lg border border-[#212425]">
          <div className="flex items-center relative gap-2">
            <p className="text-[15px] font-semibold text-left text-white">
              Merge Medium Impact Task PR
            </p>
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4 relative"
              preserveAspectRatio="none"
            >
              <path
                d="M6.66667 5.16669L10 8.50002L6.66667 11.8334"
                stroke="white"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="h-px bg-[#212425]" />
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <div className="flex items-center relative gap-0.5">
                <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 relative"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M7.73225 3.07942C7.84171 2.85764 8.15796 2.85764 8.26742 3.07942L9.68434 5.95042C9.72781 6.03849 9.81183 6.09954 9.90902 6.11366L13.0774 6.57405C13.3221 6.60961 13.4198 6.91039 13.2427 7.08302L10.9501 9.31778C10.8798 9.38634 10.8477 9.48511 10.8643 9.5819L11.4055 12.7374C11.4473 12.9812 11.1915 13.1671 10.9725 13.052L8.13869 11.5622C8.05176 11.5165 7.94791 11.5165 7.86098 11.5622L5.02713 13.052C4.80822 13.1671 4.55237 12.9812 4.59417 12.7374L5.13539 9.5819C5.15199 9.48511 5.1199 9.38634 5.04957 9.31778L2.75694 7.08302C2.57984 6.91039 2.67757 6.60961 2.92232 6.57405L6.09066 6.11366C6.18785 6.09954 6.27187 6.03849 6.31533 5.95042L7.73225 3.07942Z"
                    fill="#6B6D6E"
                  />
                </svg>
                <p className="text-xs font-medium text-left text-[#6b6d6e]">
                  Rewards
                </p>
              </div>
              <div className="flex items-center relative gap-1">
                <p className="text-[13px] font-medium text-left text-[#ff4949]">
                  234.23 DAG ($23)
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center relative gap-0.5">
                <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 relative"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M2.66708 6.00925L2.66702 11.3005C2.66702 11.9142 3.16448 12.4117 3.77813 12.4117L12.2219 12.4117C12.8355 12.4117 13.333 11.9142 13.333 11.3006L13.3332 5.78468C13.3332 5.47785 13.0844 5.22911 12.7776 5.22911H8.04633L6.51021 3.5882H3.22227C2.91536 3.5882 2.6666 3.83665 2.66669 4.14355C2.66686 4.67178 2.66708 5.46451 2.66708 6.00925Z"
                    fill="#6B6D6E"
                  />
                </svg>
                <p className="text-xs font-medium text-left text-[#6b6d6e]">
                  Project
                </p>
              </div>
              <div className="flex items-center relative gap-1">
                <p className="text-[13px] font-medium text-left text-[#b5b6b6]">
                  Create a character art
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center relative gap-0.5">
                <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 relative"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M2.6665 12.1736C2.6665 10.076 4.41888 7.82011 7.99984 7.82011C11.5808 7.82011 13.3332 10.076 13.3332 12.1736C13.3332 12.5073 13.0897 12.7778 12.7894 12.7778H3.21029C2.90997 12.7778 2.6665 12.5073 2.6665 12.1736Z"
                    fill="#6B6D6E"
                  />
                  <path
                    d="M9.99984 5.22223C9.99984 6.3268 9.10441 7.22223 7.99984 7.22223C6.89527 7.22223 5.99984 6.3268 5.99984 5.22223C5.99984 4.11766 6.89527 3.22223 7.99984 3.22223C9.10441 3.22223 9.99984 4.11766 9.99984 5.22223Z"
                    fill="#6B6D6E"
                  />
                </svg>
                <p className="text-xs font-medium text-left text-[#6b6d6e]">
                  By
                </p>
              </div>
              <div className="flex items-center relative gap-1">
                <p className="text-[13px] font-medium text-left text-[#b5b6b6]">
                  Mansa
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center items-start gap-4">
            <div className="flex flex-col items-center relative gap-1">
              <div className="flex justify-between items-start flex-grow-0 flex-shrink-0">
                <div className="flex items-center relative gap-1">
                  <p className="text-[13px] font-bold text-left text-[#525556]">
                    0
                  </p>
                  <p className="text-[11px] font-medium text-left text-[#525556]">
                    (0.0%)
                  </p>
                </div>
                <div className="flex justify-end items-center relative gap-1">
                  <p className="text-[11px] font-medium text-left text-[#525556]">
                    (0.0%)
                  </p>
                  <p className="text-[13px] font-bold text-left text-[#525556]">
                    0
                  </p>
                </div>
              </div>
              <svg
                width={272}
                height={4}
                viewBox="0 0 272 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="h-1"
                preserveAspectRatio="none"
              >
                <path
                  d="M0 2C0 0.895431 0.895431 0 2 0H270C271.105 0 272 0.895431 272 2C272 3.10457 271.105 4 270 4H2C0.895432 4 0 3.10457 0 2Z"
                  fill="#2D3031"
                />
              </svg>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center items-start relative gap-3 p-4 rounded-lg border border-[#212425]">
          <div className="flex items-center relative gap-2">
            <p className="text-[15px] font-semibold text-left text-white">
              If Yes/No was available directly
            </p>
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4 relative"
              preserveAspectRatio="none"
            >
              <path
                d="M6.66667 5.16663L10 8.49996L6.66667 11.8333"
                stroke="white"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="h-px bg-[#212425]" />
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <div className="flex items-center w-[75px] relative gap-0.5">
                <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 relative"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M2.66708 6.00931L2.66702 11.3006C2.66702 11.9142 3.16448 12.4117 3.77813 12.4117L12.2219 12.4117C12.8355 12.4117 13.333 11.9143 13.333 11.3007L13.3332 5.78474C13.3332 5.47791 13.0844 5.22917 12.7776 5.22917H8.04633L6.51021 3.58826H3.22227C2.91536 3.58826 2.6666 3.83671 2.66669 4.14362C2.66686 4.67185 2.66708 5.46458 2.66708 6.00931Z"
                    fill="#6B6D6E"
                  />
                </svg>
                <p className="text-xs font-medium text-left text-[#6b6d6e]">
                  Project
                </p>
              </div>
              <div className="flex items-center relative gap-1">
                <p className="text-[13px] font-medium text-left text-[#b5b6b6]">
                  Create a character art
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center w-[75px] relative gap-0.5">
                <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 relative"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M2.6665 12.1736C2.6665 10.0761 4.41888 7.82017 7.99984 7.82017C11.5808 7.82017 13.3332 10.0761 13.3332 12.1736C13.3332 12.5073 13.0897 12.7778 12.7894 12.7778H3.21029C2.90997 12.7778 2.6665 12.5073 2.6665 12.1736Z"
                    fill="#6B6D6E"
                  />
                  <path
                    d="M9.99984 5.22229C9.99984 6.32686 9.10441 7.22229 7.99984 7.22229C6.89527 7.22229 5.99984 6.32686 5.99984 5.22229C5.99984 4.11772 6.89527 3.22229 7.99984 3.22229C9.10441 3.22229 9.99984 4.11772 9.99984 5.22229Z"
                    fill="#6B6D6E"
                  />
                </svg>
                <p className="text-xs font-medium text-left text-[#6b6d6e]">
                  By
                </p>
              </div>
              <div className="flex items-center relative gap-1">
                <p className="text-[13px] font-medium text-left text-[#b5b6b6]">
                  Mansa
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center items-start gap-4">
            <div className="flex flex-col items-center relative gap-1">
              <div className="flex justify-between items-start flex-grow-0 flex-shrink-0">
                <div className="flex items-center relative gap-1">
                  <p className="text-[13px] font-bold text-left text-[#525556]">
                    0
                  </p>
                  <p className="text-[11px] font-medium text-left text-[#525556]">
                    (0.0%)
                  </p>
                </div>
                <div className="flex justify-end items-center relative gap-1">
                  <p className="text-[11px] font-medium text-left text-[#525556]">
                    (0.0%)
                  </p>
                  <p className="text-[13px] font-bold text-left text-[#525556]">
                    0
                  </p>
                </div>
              </div>
              <svg
                width={272}
                height={4}
                viewBox="0 0 272 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="h-1"
                preserveAspectRatio="none"
              >
                <path
                  d="M0 2C0 0.895431 0.895431 0 2 0H270C271.105 0 272 0.895431 272 2C272 3.10457 271.105 4 270 4H2C0.895432 4 0 3.10457 0 2Z"
                  fill="#2D3031"
                />
              </svg>
            </div>
          </div>
          <div className="flex items-center h-10 gap-2">
            <div
              className="flex justify-center items-center h-11 relative gap-1 px-6 rounded-lg bg-[#60e25e]"
              style={{ boxShadow: "0px 3px 0px 0 #439e42" }}
            >
              <p className="text-base font-bold text-justify text-[#080c0d]">
                Yes
              </p>
            </div>
            <div
              className="flex justify-center items-center h-11 relative gap-1 px-6 rounded-lg bg-[#ff4949]"
              style={{ boxShadow: "0px 3px 0px 0 #b33333" }}
            >
              <p className="text-base font-bold text-justify text-[#080c0d]">
                No
              </p>
            </div>
          </div>
        </div> */}
      </div>
  )
}
